import { Box, Select, SelectProps } from '@amzn/awsui-components-core';
import arraySort from 'array-sort';
import {
  ContentAccessUser,
  ContentHistory,
  ContentWorkflow,
  IntegerStringConverter,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useState } from 'react';
import constants from '../../common/constants';
import { workflowStateDisplayNames } from '../utils/DisplayNames';
import CommentThreadsView from './CommentThreadsView';
interface Props {
  contentId: string;
  workflow?: ContentWorkflow;
  sectionId?: string;
  coAuthors?: ContentAccessUser[];
  workflowHistory?: ContentHistory[];
}
const converter = new IntegerStringConverter();

const CommentHistory = (props: Props) => {
  const { contentId, workflow, sectionId, coAuthors } = props;
  // @ts-expect-error TS2339 - strict migration
  const { draftState, draftWorkflowId } = workflow;
  const [selectedVersion, setSelectedVersion] = useState<SelectProps.Option | null>(null);

  // @ts-expect-error TS7006 - strict migration
  const updateSelectedVersion = (event) => {
    const value = event.detail.selectedOption;
    setSelectedVersion(value);
  };

  let workflowHistory = props.workflowHistory;
  // If workflow hasn't been modified, the latest published workflow is treated as active workflow
  if (draftState === WorkflowState.UNMODIFIED) {
    workflowHistory = workflowHistory?.filter((wf) => wf.workflowId < draftWorkflowId - 1);
  }

  // @ts-expect-error TS2345 - strict migration
  arraySort(workflowHistory, 'workflowId', { reverse: true });
  const versionSelectOptions: SelectProps.Option[] = (workflowHistory ?? []).map((wf) => ({
    description: `${workflowStateDisplayNames.get(wf.state)}`,
    value: wf.workflowId.toString(),
    label: `Version ${wf.workflowId}`,
  }));
  const verionSelectionBox = (
    <Select
      selectedOption={selectedVersion}
      placeholder={constants.COMMENTS_VERSION_SELECTION_PLACEHOLDER}
      options={versionSelectOptions}
      onChange={updateSelectedVersion}
      ariaRequired
    />
  );

  const commentHistory = selectedVersion ? (
    <CommentThreadsView
      contentId={contentId}
      workflowId={converter.deserialize(selectedVersion.value ?? '')}
      // @ts-expect-error TS2322 - strict migration
      sectionId={sectionId}
      coAuthors={coAuthors}
      authorId={workflow && workflow.ownerId}
      visible
      resolveEnabled
      showHistory={false}
      isEditable={false}
    />
  ) : null;
  return (
    <div>
      <Box padding={{ bottom: 's' }}>{verionSelectionBox}</Box>
      {commentHistory}
    </div>
  );
};

export default CommentHistory;
